import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import store, { persistor } from './store';
import Theme from 'components/template/Theme';
import Layout from 'components/layout';
import NoPermission from 'views/pages/Welcome/NoPermission';
import Sidebar from 'views/pages/Welcome/MenuCard';

function App() {
  const [notification, setNotification] = useState({ title: '', body: '' });

  // // Block right-click and common DevTools shortcuts
  // useEffect(() => {
  //   const handleContextMenu = (e) => e.preventDefault();
  //   const handleKeyDown = (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") ||
  //       (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "j") ||
  //       (e.ctrlKey && e.key.toLowerCase() === "u")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Theme>
            <Layout />
            <Routes>
              <Route path="/" element={<Sidebar />} />
              <Route path="/no-permission" element={<NoPermission />} />
            </Routes>
          </Theme>
        </BrowserRouter>
      </PersistGate>
      <ToastContainer />
    </Provider>
  );
}

export default App;
